import { observer } from "mobx-react-lite";
import { Body } from "../../../ui/Body";
import { Box } from "../../../ui/Box";
import { BusinessModuleEditor } from "../../../ui/editor/useModuleEditor";
import { BusinessModuleBlock } from "../ui/BusinessBlock";
import type BusinessInfoModuleModel from "./BusinessInfoModel";

export const BusinessInfoModuleUI = observer(
  ({ businessModule }: { businessModule: BusinessInfoModuleModel }) => {
    return (
      <Box>
        <BusinessModuleEditor businessModule={businessModule} />
      </Box>
    );
  },
);

// Only title
export const BusinessInfoModuleBlockUI = observer(
  ({ businessModule }: { businessModule: BusinessInfoModuleModel }) => {
    return (
      <BusinessModuleBlock
        businessModule={businessModule}
      ></BusinessModuleBlock>
    );
  },
);

// Not used...
export const BusinessInfoModuleFeedItemUI = observer(
  ({ businessModule }: { businessModule: BusinessInfoModuleModel }) => {
    return (
      <BusinessModuleBlock businessModule={businessModule}>
        <Body>FEED ITEM CONTENT</Body>
      </BusinessModuleBlock>
    );
  },
);
